module.exports = __webpack_public_path__ + "static/img/1014_big.123774d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1014_big.png
// module id = PWso
// module chunks = 1